import type { ConfigureStore } from './types';

export const configureStore: ConfigureStore = (function () {
    return process.env.NODE_ENV === 'development' &&
        process.env.REACT_APP_TARGET === 'web'
        ? require('./configureStore.debug').default
        : require('./configureStore.main').default;
})();
